<div class="element-column" id="vw_ImageInfoDetail">
  <div class="block-row">
    <!-- 画像情報詳細部の画像表示部分 -->
    <div>
      <div *ngIf="this.imagePreviewURL">
        <img id="img_GoodsImage" src="{{imagePreviewURL}}" forcedEnabledMode="true" #img_GoodsImage
          verticalAlign="middle" horizontalAlign="center" autoLoad="true" cachePolicy="off" cacheAsBitmap="false">
      </div>
    </div>
    <!-- 画像情報詳細部の項目表示部分 -->
    <app-image-info-detail-box id="imageInfoDetailBox" #imageInfoDetailBox [parentModel]="parentModel">
    </app-image-info-detail-box>
  </div>
  <div class="layout_balance">
    <!-- 画像情報詳細部のボタン群 -->
    <div class="element-row">
      <button class="btn-tartiary warning" id="btn_Delete"
        [disabled]="!btnDeleteEnabled" (click)="eventDeleteCLICK.emit()" [tabindex]="-1">画像を削除</button>
      <button class="btn-tartiary" id="btn_Reset"
        [disabled]="!btnResetEnabled" (click)="eventResetCLICK.emit()" [tabindex]="-1">リセット</button>
    </div>

    <div class="element-row">
      <button class="btn-secondary" id="btn_UseStop"
        [disabled]="!btnUseStopEnabled" (click)="eventUseStopCLICK.emit()" [tabindex]="-1">使用停止</button>
      <button class="btn-secondary" id="btn_UseUnStop"
        [disabled]="!btnUseUnStopEnabled" (click)="eventUseUnStopCLICK.emit()" [tabindex]="-1">使用停止解除</button>
      <button class="btn-primary" id="btn_Setting"
        [disabled]="!btnSettingEnabled" (click)="eventSettingCLICK.emit()" [tabindex]="-1">設定</button>
    </div>
  </div>
</div>
